import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const GROUP = 'add group'
export const CLIENT_ID = 'CLIENT_ID'
export const RATE_CARD = 'rate card'
export const SAVE_GROUP = 'save group'
export const REQUIRED_FIELDS = 'required fields'
export const CHANGES_SAVED = 'changes saved'

export default {
  [PORTUGUESE]: {
    [GROUP]: 'Grupo',
    [CLIENT_ID]: 'Id do Cliente',
    [RATE_CARD]: 'Tabela de Preços',
    [SAVE_GROUP]: 'Salvar Grupo',
    [REQUIRED_FIELDS]: 'Por favor preencha os campos obrigatórios',
    [CHANGES_SAVED]: 'As mudanças foram salvas',
  },

  [ENGLISH]: {
    [GROUP]: 'Group',
    [CLIENT_ID]: 'Client Id',
    [RATE_CARD]: 'Rate Card',
    [SAVE_GROUP]: 'Save Group',
    [REQUIRED_FIELDS]: 'Please fill in the required fields',
    [CHANGES_SAVED]: 'Changes have been saved',
  },

  [SPANISH]: {
    [GROUP]: 'Grupo',
    [CLIENT_ID]: 'Identificación del Cliente',
    [RATE_CARD]: 'Tarjeta de Tarifa',
    [SAVE_GROUP]: 'Guardar Grupo',
    [REQUIRED_FIELDS]: 'Por favor llene los campos requeridos',
    [CHANGES_SAVED]: 'Los cambios han sido guardados',
  },
}
